import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import TextareaAutosize from 'react-autosize-textarea';
import {langRegister} from "../../services/langRegister";
import innerHtml from 'react-inner-html';
import {marketRegister} from "../../services/marketRegister";
import ReactGA from 'react-ga';
import ErrorHandler from "../../components/error-handler/component";

class SignupQuotes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            quotes: [],
            selected: {},
            isLoadingButton: false,
            isLoading: true,
            page: 1,
            page_load: 5,
            admin: false,
            customQuote: {
                selected: false,
                saved: false,
                text: "",
                modal: false,
                custom: true
            },
            customCount: 0,
            error: false,
            sale: "instant"
        };
        this._renderAdminQuote = this._renderAdminQuote.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateUser();

        //GOOGLE ANALYTICS
        if(window.location.href.indexOf("devadbop.com") === -1){
            ReactGA.pageview('/signup-quotes');
        }

        //CHECK VIEW
        let view = quotesRegister.getView();
        if(!view){
            cartRegister.setQuotes(null);
        }
        quotesRegister.setView("custom");
    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({admin: user.reseller || user.inhouse}, () => {
                    this._updateQuantity();
                });
            }else{
                this._updateQuantity();
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuantity(){
        if(window.innerWidth > 1050){
            this.setState({page_load: 10}, () => {
                this._updateData();
            });
        }else{
            this.setState({page_load: 8}, () => {
                this._updateData();
            });
        }
    }

    _updateData() {
        try {
            let stored_data = cartRegister.get();

            //SET SALE TYPE
            this.setState({sale:stored_data.crossroad});
            if (stored_data.admin_image) {
                if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                    this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
                }
            }
            if (stored_data.industry && (stored_data.image || stored_data.admin_image)) {
                this.setState({
                    industry: stored_data.industry
                }, () => {
                    this._updateQuotes(this.state.industry.id, marketRegister.code(), langRegister.lang());
                });
            } else {
                this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuotes(industry, market, lang) {
        try {
            let stored_quotes = quotesRegister.get();
            let stored_page = quotesRegister.page();
            if (stored_quotes) {
                this.setState({
                    quotes: stored_quotes,
                    page: stored_page,
                    isLoading: false
                }, () => {
                    this._updateQuote();
                });
            } else {
                dataRegister.quotes(industry, market, lang).then((data) => {
                    if (data.errors) {
                        this.setState({
                            isLoading: false
                        });
                    } else {
                        let quotes = data;

                        //REMOVE INDUSTRY SLOGANS
                        let industry_slogans = [];
                        let other_quotes = [];
                        for(let i = 0; i < quotes.length; i++){
                            if(quotes[i].slogan.indexOf(this.state.industry.name) !== -1){
                                industry_slogans.push(quotes[i]);
                            }else{
                                other_quotes.push(quotes[i]);
                            }
                        }

                        other_quotes.sort(function(a, b) {
                            var textA = a.slogan.toUpperCase();
                            var textB = b.slogan.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });

                        industry_slogans = industry_slogans.concat(other_quotes);

                        this.setState({
                            quotes: industry_slogans,
                            isLoading: false
                        }, () => {
                            quotesRegister.set(this.state.quotes, 1, lang);
                            this._updateQuote();
                        });
                    }
                }, (error) => {
                    this.setState({error: true});
                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuote() {
        try {
            let stored_quotes = cartRegister.get();
            if (stored_quotes.admin_quotes) {
                this.setState({
                    customQuote: stored_quotes.admin_quotes
                });
            } else if (stored_quotes.quotes) {
                this.setState({
                    selected: stored_quotes.quotes
                }, () => {

                    console.log(this.state.selected);

                    //FILTER BY SELECTED QUOTES
                    let quotes = [];
                    let selected = [];

                    for(let i = 0; i < this.state.quotes.length; i++){
                        if(this.state.selected[this.state.quotes[i].id]){
                            selected.push(this.state.quotes[i]);
                        }else{
                            quotes.push(this.state.quotes[i]);
                        }
                    }

                    selected.sort(function(a, b) {
                        return a.index - b.index;
                    });

                    selected = selected.concat(quotes);

                    this.setState({quotes: selected});

                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectQuote(prop) {
        try {
            if (!this.state.isLoading) {
                if (this.state.customQuote.selected) {
                    this.state.customQuote.selected = false;
                    this.setState({
                        customQuote: this.state.customQuote
                    });
                }
                if (this.state.selected[prop.id]) {
                    delete this.state.selected[prop.id];
                    prop.selected = false;
                    this.setState({
                        selected: this.state.selected,
                        quotes: this.state.quotes
                    }, () => {
                        cartRegister.setQuotes(this.state.selected);
                    });

                } else {
                    if (Object.keys(this.state.selected).length > 3) {

                        setTimeout(() => {
                            this.setState({
                                isLoading: true
                            });
                        }, 400);
                        cartRegister.setQuotes(this.state.selected);
                        quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                        setTimeout(() => {
                            this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/business");
                        }, 1000);

                    } else {
                        prop.selected = true;
                        this.state.selected[prop.id] = prop;
                        let index = 0;
                        for(let key in this.state.selected){
                            if(this.state.selected[key].index && this.state.selected[key].index > index){
                                index = this.state.selected[key].index;
                            }
                        }
                        index++;
                        this.state.selected[prop.id].index = index;
                        this.setState({
                            selected: this.state.selected,
                            quotes: this.state.quotes
                        }, () => {
                            cartRegister.setQuotes(this.state.selected);
                            if (Object.keys(this.state.selected).length > 3) {
                                setTimeout(() => {
                                    this.setState({
                                        isLoading: true
                                    });
                                }, 400);
                                quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                                setTimeout(() => {
                                    this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/business");
                                }, 1000);
                            }
                        });

                    }
                }
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectCustomQuote() {
        try {
            if (!this.state.isLoading) {
                this.state.customQuote.selected = true;
                this.setState({
                    customQuote: this.state.customQuote,
                    selected: {}
                });
                cartRegister.setAdAdminQuotes(this.state.customQuote);
                this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/business");
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _setCustomQuote(){

        try {
            let words = this.state.customQuote.text.split(" ");
            for(let i = 0; i < words.length; i++){
                words[i] = capitalizeFLetter(words[i]);
            }
            this.state.customQuote.text = words.join(" ");
        }catch (e) {
            console.log(e);
        }

        this.state.quotes.unshift({
            slogan: this.state.customQuote.text,
            id: "custom_" + this.state.quotes.length + Math.floor(Math.random() * 100000) + 1,
            custom: true,
            sale: "both",
            type: "both",
            index: 0
        });

        this.setState({quotes: this.state.quotes, customCount: this.state.customCount + 1}, () => {
            quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
        });

        function capitalizeFLetter(string) {
            return  string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

    _addCustomQuote() {
        try {
            this.state.customQuote.modal = true;
            this.state.customQuote.text = "";
            this.setState({
                customQuote: this.state.customQuote
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _moreQuotes() {
        try {
            this.setState({page_load: window.innerWidth > 1050?5:4}, () => {
                this.setState({
                    page: this.state.page + (this.state.page === 1?2:1)
                }, () => {
                    this._scrollTo("bottom");
                    quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                });
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _next(){
        if(Object.keys(this.state.selected).length > 3){
            /*if(this.state.customQuote.saved && this.state.customQuote.selected){
                cartRegister.setAdAdminQuotes(this.state.customQuote);
            }
            */
            this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/business");
        }
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
        }
    }

    _renderAdminQuote(e){
        try{
            const re = /^[\x00-\xFF]*$/;
            if (e.target.value === '' || re.test(e.target.value)) {
                this.state.customQuote.text = e.target.value;
                this.setState({customQuote: this.state.customQuote});
            }
        }catch (e) {
            console.log(e);
        }
    }

    _renderQuote(slogan){
        try {
            let string = slogan.replace(this.state.industry.name, '<bold><div>&nbsp;'+this.state.industry.name+'&nbsp;</div></bold>');
            return (<span {...innerHtml(string)}></span>);
        }catch (error) {
            return slogan;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-quotes", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"signup"} props={this.props}/>

                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            {
                                this.state.customQuote.modal &&
                                <div>
                                    {this._renderText("item_5")}
                                </div>
                                ||
                                <div>
                                    {this._renderText("item_1")}
                                </div>
                            }
                        </div>
                        <div className={Styles.quotesContainer}>
                            {
                                false &&
                                this.state.customQuote.saved && !this.state.customQuote.modal &&
                                <div
                                    className={
                                        cx(Styles.quotesContainerItemCustom,
                                            {
                                                [Styles.quotesContainerItemActive]: this.state.customQuote.selected,
                                            })
                                    }
                                    onClick={() => this._selectCustomQuote()}
                                >
                                    <div className={Styles.quotesContainerItemCustomQuote}>
                                        {this.state.customQuote.text}
                                    </div>
                                    <div onClick={(event) => {
                                        event.stopPropagation();
                                        this.state.customQuote.modal = true;
                                        this.setState({customQuote: this.state.customQuote});
                                    }}
                                         className={
                                             cx(Styles.quotesContainerItemCustomEditButton,
                                                 {
                                                     [Styles.quotesContainerItemCustomEditButtonActive]: this.state.customQuote.selected,
                                                 })
                                         }>
                                        <img className={Styles.quotesContainerItemCustomEditButtonIcon} src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    </div>
                                </div>
                            }
                            {
                                !this.state.customQuote.modal && this.state.admin &&
                                <div
                                     onClick={() => this._addCustomQuote()}
                                     className={Styles.quotesContainerItem}>
                                    <div className={Styles.quotesContainerItemQuote}>
                                        <div className={Styles.quotesContainerItemQuoteIcon}>
                                            +
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                !this.state.customQuote.modal &&
                                this.state.quotes.filter((item) => {
                                    return (item.sale === this.state.sale || item.sale === "both")
                                }).filter((item) => {
                                    return (item.type === "both" || (item.type === "service" && +this.state.industry.type === 1) || (item.type === "product" && +this.state.industry.type === 2))
                                }).filter((item, i) => {
                                    if(this.state.admin && this.state.page === 1){
                                        if(window.innerWidth > 1050){
                                            return i < 4 + this.state.customCount
                                        }else{
                                            return i < 5 + this.state.customCount
                                        }
                                    }else if(this.state.admin){
                                        return i < (this.state.page * this.state.page_load - 1) + this.state.customCount
                                    }else{
                                        return i < (this.state.page * this.state.page_load) + this.state.customCount
                                    }
                                }).map((prop, i) => {
                                    return (
                                          <div key={i}
                                               onClick={() => this._selectQuote(prop)}
                                               className={
                                                   cx(Styles.quotesContainerItem,
                                                         {
                                                             [Styles.quotesContainerItemActive]: this.state.selected[prop.id],
                                                         })
                                               }>
                                              <div className={Styles.quotesContainerItemQuote}>
                                                  {this._renderQuote(prop.slogan)}
                                              </div>
                                          </div>
                                    )
                                })
                            }
                            {
                                this.state.customQuote.modal &&
                                <div className={Styles.customQuote}>
                                    <input
                                        value={this.state.customQuote.text}
                                        onChange={this._renderAdminQuote}
                                        placeholder={this._renderText("item_6")}
                                        maxLength={30}
                                        className={Styles.customQuoteTextArea}
                                    />
                                    {
                                        this.state.customQuote.modal &&
                                        <div className={Styles.customQuoteButtons}>
                                            <div className={Styles.customQuoteButtonsItem}>
                                                <div onClick={() => {
                                                    this.state.customQuote.text = "";
                                                    this.state.customQuote.saved = false;
                                                    this.state.customQuote.modal = false;
                                                    this.state.customQuote.selected = false;
                                                    this.setState({customQuote: this.state.customQuote})
                                                }} className={Styles.customQuoteButtonsItemRemove}>
                                                    <img className={Styles.customQuoteButtonsItemRemoveIcon}
                                                         src={require("../../assets/images/AB_cross_bold.png")}/>
                                                </div>
                                            </div>
                                            <div className={Styles.customQuoteButtonsItem}>
                                                <div
                                                    onClick={() => {
                                                        if (this.state.customQuote.text !== "") {
                                                            this.state.customQuote.saved = true;
                                                            this.state.customQuote.modal = false;
                                                            this.setState({
                                                                customQuote: this.state.customQuote
                                                            }, () => {
                                                                this._setCustomQuote()
                                                            })
                                                        }
                                                    }
                                                    }
                                                    className={
                                                        cx(Styles.customQuoteButtonsItemSave,
                                                            {
                                                                [Styles.customQuoteButtonsItemSaveActive]: this.state.customQuote.text !== "",
                                                            })
                                                    }>
                                                    <img className={Styles.customQuoteButtonsItemRemoveIcon}
                                                         src={require("../../assets/images/AB_checkmark_bold.png")}/>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        {
                            !this.state.customQuote.modal &&
                            <div onClick={() => this._moreQuotes()} className={
                                cx(Styles.plusIcon,
                                    {
                                        [Styles.plusIconActive]: this.state.quotes.filter((item) => {
                                            return (item.sale === this.state.sale || item.sale === "both")
                                        }).filter((item) => {
                                            return (item.type === "both" || (item.type === "service" && +this.state.industry.type === 1) || (item.type === "product" && +this.state.industry.type === 2))
                                        }).length > (this.state.page * this.state.page_load),
                                    })
                            }>
                                {
                                    this.state.isLoadingButton &&
                                    <BeatLoader size={12} color={'#ffffff'} loading={true}/>
                                    ||
                                    <img className={Styles.plusIconItem}
                                         src={require("../../assets/images/plus_sign_white_small.png")}/>
                                }
                            </div>
                        }
                        {
                            !this.state.customQuote.modal &&
                            <div>
                                {
                                    false &&
                                    <div className={
                                        cx(Styles.button,
                                            {
                                                [Styles.buttonActive]: Object.keys(this.state.selected).length > 3 || this.state.customQuote.saved,
                                            })
                                    } onClick={() => this._next()}>
                                        <div>{this._renderText("item_3")}</div>
                                    </div>
                                }
                                <div onClick={() => this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/image")}
                                     className={
                                         cx(Styles.backButton,
                                             {
                                                 [Styles.backButtonCenter]: true,
                                             })
                                     }>
                                    {this._renderText("item_4")}
                                </div>
                            </div>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width:"100%"}}/>
            </div>
        );
    }
}

export default SignupQuotes;


// WEBPACK FOOTER //
// ./src/pages/signup-quotes/component.js